import { useEffect, useEffectEvent, useRef } from 'react';

import { durationProps } from '@cfa/pathway-fe-shared';
import { AmplitudeProductEvent } from '@cfa/pathway-fe-shared';

import { useAmplitudeTrack } from '@/amplitude/useAmplitude';

/**
 * Tracks how long the "Choose Team Member" modal stays open and fires
 * a `choose_team_member_modal_duration` Amplitude event when it closes.
 */
export const useModalDurationTracking = (
  isOpen: boolean,
  eventProperties?: Record<string, unknown>,
) => {
  const track = useAmplitudeTrack();
  const openTimeRef = useRef<number | null>(null);

  const onModalClose = useEffectEvent(() => {
    if (openTimeRef.current === null) return;

    const elapsedMs = performance.now() - openTimeRef.current;
    track(AmplitudeProductEvent.CHOOSE_TEAM_MEMBER_MODAL_DURATION, {
      ...durationProps(elapsedMs),
      ...eventProperties,
    });
    openTimeRef.current = null;
  });

  useEffect(() => {
    if (isOpen) {
      openTimeRef.current = performance.now();
    } else {
      onModalClose();
    }
  }, [isOpen]);
};
